<template>
    <v-dialog 
        v-model="dialogSeatPlan"
        :fullscreen="$vuetify.display.smAndDown" 
        transition="dialog-top-transition"
        attach="body"
        class="seatPlanDialog">
        
        <v-card class="">
            <v-row dense class="align-center justify-end mr-1 mt-1">
                <v-col cols="auto">
                    <ExitButton @click="dialogSeatPlan = false"/>
                </v-col>
            </v-row>
            <v-row class="align-center justify-center mt-n10">
                <v-col cols="auto">
                    <v-card-title>{{ dialogSeatPlanSeat.description }}</v-card-title>
                </v-col>
            </v-row>
            <v-row class="align-center justify-center mt-n6">
                <v-col cols="auto">
                    <v-card-subtitle>{{ dialogSeatPlanSeat.room + ', Platz ' + dialogSeatPlanSeat.name }}</v-card-subtitle>
                </v-col>
            </v-row>
            <v-row dense class="align-center justify-center ma-5 mt-0">
                <v-col cols="auto">
                    <SeatPlan 
                    :seatPlanImagePath="dialogSeatPlanImagePath"
                    :seatPlanSeatXpos="dialogSeatPlanSeat.x_pos"
                    :seatPlanSeatYpos="dialogSeatPlanSeat.y_pos"/>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
</template>

<script>

import ExitButton from '../consumables/ExitButton.vue';
import SeatPlan from '../consumables/SeatPlan.vue';

export default {
    components:{
        ExitButton,
        SeatPlan
    },

    props:{
        dialogSeatPlanImagePath: {
            type: String,
            required: true
        },
        dialogSeatPlanSeat: {
            type: Object,
            required: true,
            default: null
        },
    },

    data() {
        return {
            dialogSeatPlan: false,
        }
    },

    methods:{
        openDialogSeatPlan(){
            this.dialogSeatPlan = true;
        }
    }
}
</script>

<style scoped>

.seatPlanDialog{
    max-width: 1080px;
}
.v-card{
    border-radius: 16px !important;
}
</style>